import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const logoCarousel = document.querySelector(".logo-carousel");

const initLogoCarousel = () => {
  new Splide(logoCarousel, {
    type: "loop",
    drag: "free",
    focus: "center",
    perPage: 5,
    gap: 60,
    pauseOnHover: false,
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
    },
    breakpoints: {
      440: {
        perPage: 2,
        gap: 40,
        autoScroll: {
          speed: 0.5,
        },
      },
      900: {
        perPage: 4,
        gap: 40,
      },
    },
    pagination: false,
    arrows: false,
  }).mount({ AutoScroll });
};

if (logoCarousel) {
  initLogoCarousel();
}

const teamSlider = document.querySelector(".team-slider");

const initTeamSlider = () => {
  const splide = new Splide(teamSlider, {
    type: "fade",
    perPage: 1,
    pagination: true,
    arrows: true,
    rewind: true,
  });

  splide.mount();
};

if (teamSlider) {
  initTeamSlider();
}

const showcaseSlider = document.querySelector(".showcase-slider");

const initShowcaseSlider = () => {
  new Splide(showcaseSlider, {
    type: "fade",
    perPage: 1,
    pagination: true,
    arrows: true,
    rewind: true,
  }).mount();
};

if (showcaseSlider) {
  initShowcaseSlider();
}

const imageSlider = document.querySelector(".image-slider");

const initImageSlider = () => {
  new Splide(imageSlider, {
    type: "slider",
    pagination: false,
    arrows: true,
    rewind: true,
    gap: 16,
    perPage: 3,
    breakpoints: {
      440: {
        perPage: 1,
      },
      768: {
        perPage: 3,
      },
    },
  }).mount();
};

if (imageSlider) {
  initImageSlider();
}

const testimonialSlider = document.querySelector(".testimonial-slider");

const initTestimonialSlider = () => {
  new Splide(testimonialSlider, {
    type: "fade",
    autoplay: true,
    perPage: 1,
    pagination: true,
    arrows: true,
    rewind: true,
  }).mount();
};

if (testimonialSlider) {
  initTestimonialSlider();
}
